import React from 'react'
import { IconButton, Tooltip } from '@mui/material'

const CustomIconButton = ({ onClick, tooltipTitle, icon }) => (
  <Tooltip arrow title={tooltipTitle}>
    <IconButton onClick={onClick}>
      {icon}
    </IconButton>
  </Tooltip>
)

export default CustomIconButton
